import React from 'react';
import './TelegramModal.css';

const TelegramModal = ({ bindTg, skipTg }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-icon">
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#4aae88" strokeWidth="1.7" strokeLinejoin="round">
            <path d="M4 5h16v11H8l-4 4z" />
            <path d="M8 10h8M8 13h5" />
          </svg>
        </div>
        <div className="modal-title">Привяжите Telegram</div>
        <p className="modal-text">
          Привяжите Telegram, чтобы управлять подпиской из бота. Это можно сделать позже в настройках.
        </p>
        <button onClick={bindTg} className="modal-btn-primary">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinejoin="round">
            <path d="M4 5h16v11H8l-4 4z" />
          </svg>
          Привязать Telegram
        </button>
        <button onClick={skipTg} className="modal-btn-secondary">Не сейчас</button>
      </div>
    </div>
  );
};

export default TelegramModal;